import React, { FC, useLayoutEffect } from 'react';
import { Button, useIsInIframe, X } from 'shared-components';

export const CloseIframeOnSuccessButton: FC<{}> = ({}) => {
  const isOpenedInIframe = useIsInIframe();
  useLayoutEffect(() => {
    if (isOpenedInIframe) {
      window.parent.postMessage(JSON.stringify({ type: 'success' }), '*');
    }
  }, [isOpenedInIframe]);
  return isOpenedInIframe ? (
    <Button
      variant="primary-white"
      onClick={() => {
        window.parent.postMessage(JSON.stringify({ type: 'close' }), '*');
      }}
    >
      Close
    </Button>
  ) : null;
};
